export default __webpack_public_path__ + "static/media/noggin.57235177.png";